export default {
	section_banner: {
		title: {
			one: 'グローバル',
		},
		main_title: '支払い',
		sub_title: '処理',
		paragraph: {
			one: 'JPWorldPayを受け取って、ご希望の国に出金できます。JPWorldPayはグローバルなアクセス性を備えているため、どこからでも支払いを受け付けることができます。',
		},
		cta_buttons: {
			one: 'Get Started',
			two: 'Download App',
		},
	},

	question_sec: {
		label: '自動的に適用',
		title: {
			one: '現在まで',
			two: '交換 ',
			three: 'レート',
		},
		paragraph:
			'いつでも好きな時にお金を引き出せます。JPWorldPayなら、資金を自由に管理でき、いつでも制限なくアクセス・引き出しが可能です。ビジネス用途でもプライベート用途でも、柔軟かつ自由に資金を管理し、思いのままに資金管理をお楽しみください。',
		cta_buttons: {
			one: '始めましょう',
		},
	},

	global_mid: {
		label: 'JPWorldPayカスタマー',
		title: {
			one: '作る',
			two: '支払い',
			three: '国を問わず',
		},
		paragraph:
			'JPWorldPayのお客様は、居住国を問わず決済を行うことができます。グローバルなアクセス性により、ユーザーは地域的な制限を気にすることなく、国境を越えてシームレスに送金・受取が可能です。これにより、JPWorldPayは、迅速、安全、そして国境を越えた金融取引を求める企業や個人にとって、真に国際的なソリューションとなります。',
		cta_buttons: {
			one: '始めましょう',
		},
	},

	online_mid: {
		label: '隠れた手数料なし',
		title: {
			one: '使用する理由',
			two: '暗号通貨',
		},
		paragraph:
			'最大のメリットは、為替レートの数だけ確認するだけで済むことです。JPWorldPayは適用可能なレートを明確に表示することで、通貨換算プロセス全体を簡素化します。そのため、常に正確なレートを把握できます。隠れた手数料や複雑な計算は一切なく、透明性が高く、より賢明な財務判断を容易に行うことができます。',
		cta_buttons: {
			one: '始めましょう',
		},
	},

	section_newsletter: {
		label: 'ニュースレターを購読する',
		title: {
			one: '購読する',
			two: '最新情報を入手',
		},
		description: {
			one: '購読して、オファーや最新情報をメールボックスに直接受け取りましょう。',
			two: '当社の JPWorldPay ソリューションが貴社のビジネスをどのように拡大できるかについて詳しくは、お問い合わせください。',
		},
		form: {
			placeholder: 'メールID',
			button: '今すぐ購読する',
		},
	},
};
